<template>
  <div id="callback">
    <LoadingSpinner />
  </div>
</template>

<script>
import LoadingSpinner from "../components/LoadingSpinner";
import { apiClient } from "../services/api";
import { TYPE } from "vue-toastification";
import { mapMutations } from 'vuex'

export default {
  components: { LoadingSpinner },
  async mounted() {
    await this.auth_request();
  },
  methods: {
    ...mapMutations({
      setUserData: 'users/setUserData'
    }),
    getParamsURLCallback() {
      var url = window.location.href;
      var params = Object.fromEntries(
        new URLSearchParams(url.split("?").pop())
      );
      return params;
    },
    warningHmlEnvironment() {
      if (process.env.VUE_APP_ENV === 'hml') {
        this.$toast("Você está acessando o ambiente de homologação.\nPara prosseguir para o ambiente de produção, acesse esse link: https://socialcam.apps.g.globo/.",
          {
            timeout: false,
            type: TYPE.ERROR,
            draggable: false,
            closeOnClick: false
          });
      }
    },
    async auth_request() {
      try {
        const { code } = this.getParamsURLCallback();

        const response = await apiClient.post('/login', { authorizationCode: code })

        if (response.status === 200) {
          this.setUserData(response.data)
          this.$router.push("/");
        } else {
          this.$toast.error("Usuário não autenticado.");
          this.warningHmlEnvironment();
          this.$router.push("/login").catch(() => {});
        }
      } catch (error) {
        if (error.name === 'TokenExpiredError') {
          this.$toast.error("Verifique se o horário de verão está habilitado, caso esteja, desative-o, e tente fazer o login novamente.", { timeout: 5000 });
        } else {
          this.$toast.error("Usuário não autenticado.");
        }
        this.warningHmlEnvironment();
        this.$router.push("/login").catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#callback {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
</style>
